import { render } from "./ActionSendEmail.vue?vue&type=template&id=273f4cc2"
import script from "./ActionSendEmail.vue?vue&type=script&lang=ts"
export * from "./ActionSendEmail.vue?vue&type=script&lang=ts"
script.render = render

export default script